import { render, staticRenderFns } from "./CustomFlag.vue?vue&type=template&id=53259070&scoped=true&"
import script from "./CustomFlag.vue?vue&type=script&lang=js&"
export * from "./CustomFlag.vue?vue&type=script&lang=js&"
import style0 from "./CustomFlag.vue?vue&type=style&index=0&id=53259070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53259070",
  null
  
)

export default component.exports